// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const AwsAutoscalingGroupsIcon = createSvgIcon(
  <svg width={40} height={40} fill="none" viewBox="0 0 40 40">
    <path fill="url(#aws-autoscaling-groups_svga)" d="M40 0H0v40h40z" />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M18.02 19.5a.5.5 0 0 0-.19-.4l-2.95-2.95-.7.7L16.3 19H7v1h9.31l-2.14 2.14.7.7 2.98-2.96a.5.5 0 0 0 .17-.38M34 19h-9.32l2.14-2.14-.7-.7-2.97 2.96a.5.5 0 0 0 .02.77l2.95 2.95.7-.7L24.67 20H34zm-13 12.32v-9.31h-1v9.31l-2.13-2.14-.7.71 2.96 2.97a.5.5 0 0 0 .77-.02l2.95-2.95-.7-.7zM17.87 9.84l-.7-.71 2.94-2.95c.18-.23.58-.24.78-.02l2.96 2.97-.7.7L21 7.7V17h-1V7.7z"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="aws-autoscaling-groups_svga"
        x1={0}
        x2={40.99}
        y1={0}
        y2={38.96}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
    </defs>
  </svg>,
  "AwsAutoscalingGroups",
);
export default AwsAutoscalingGroupsIcon;
